module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_0.4c5ee89e.png";